import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-total-messages',
  templateUrl: './tryout-total-messages.component.html',
  styleUrls: ['./tryout-total-messages.component.css']
})
export class TryoutTotalMessagesComponent implements OnInit {

  @Input() NoOfTotalMessages: string;

  //@Output() filterProgramsEvent = new EventEmitter();
  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  //this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-total-messages/tryout-total-messages.component.ts